'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresMessageController = function () {
    function WinresMessageController($scope, localizationService, messageService) {
        _classCallCheck(this, WinresMessageController);

        this.$scope = $scope;
        this.localizationService = localizationService;
        this.messageService = messageService;
    }

    _createClass(WinresMessageController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.state = 'initial';
            this.$scope.message = '';

            // This is displayed if getting the message failed AND the user didn't provide
            // a <fallback> element.
            this.$scope.ultimateFallbackMessage = "";

            this.$scope.$on('languageChanged', function () {
                return _this.refresh();
            });
            this.refresh();
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            var _this2 = this;

            var language = this.localizationService.getLanguage();
            this.$scope.state = 'loading';
            this.messageService.getMessage(this.code, language).then(function (message) {
                if (message) {
                    // console.log('[WinresMessage] Got message', this.code, ':', message);
                    _this2.$scope.message = message;
                    _this2.$scope.state = _this2.transcludeContent ? 'transclude' : 'ready';
                } else {
                    console.log('[WinresMessage] Message ' + _this2.code + ' not defined. Using fallback.');
                    _this2.$scope.message = '';
                    _this2.$scope.state = 'no-message';
                }
            }).catch(function (error) {
                _this2.$scope.message = '';
                _this2.$scope.state = 'no-message';
                console.error('[WinresMessage] Error loading message', _this2.code, ':', error);
                console.log('[WinresMessage] Using fallback.');
            });
        }
    }]);

    return WinresMessageController;
}();

WinresMessageController.$inject = ['$scope', 'localizationService', 'messageService'];

_module3.default.component('winresMessage', {
    template: require('./winresMessage.html'),
    controller: WinresMessageController,
    require: {},
    bindings: {
        code: '@',
        transcludeContent: '@'
    },
    transclude: {
        fallback: '?fallback',
        content: '?content'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresMessage/winresMessage.js
// module id = 317
// module chunks = 2